export const noResidentialTypeOptions = ['BASEMENT', 'SHOP', 'PARKING'];
